export enum UserSeriesUnit {
    MillimolPerLiter = 1,
    Celsius = 2,
    Fahrenheit = 3,
    Watt = 4
}
